
import {React , useEffect} from 'react';
import AOS from 'aos';
import { Route, Routes } from 'react-router-dom';

import routes from './pages';
import Page404 from './pages/404';

function App() {

    useEffect(() => {
        AOS.init({
          duration : 2000
        }); 
      }, []);

    return (
        <>
            <Routes>

                {
                    routes.map((data) => (
                        <Route key={data.path} path={data.path} element={data.component} />
                    ))
                }

                <Route path='*' element={<Page404 />} />
            </Routes>

    
        </>
    );
}

export default App;
